import React from 'react';
import JsonCodeEditor from '../../../shared/components/JsonCodeEditor';

interface TestEventEditorProps {
  value: Record<string, unknown>;
  onChange: (event: Record<string, unknown>) => void;
  onValidityChange?: (valid: boolean, error?: string) => void;
  error?: string;
  minHeight?: number;
}

const DEFAULT_TEST_EVENT = {
  version: '0',
  id: '12345678-1234-1234-1234-123456789012',
  'detail-type': 'EC2 Instance State-change Notification',
  source: 'aws.ec2',
  account: '123456789012',
  time: '2025-01-01T12:00:00Z',
  region: 'us-east-1',
  detail: {
    'instance-id': 'i-1234567890abcdef0',
    state: 'running',
  },
};

const TestEventEditor: React.FC<TestEventEditorProps> = ({
  value,
  onChange,
  onValidityChange,
  error,
  minHeight = 150,
}) => (
  <JsonCodeEditor
    label="Sample event"
    value={value}
    onChange={onChange}
    onValidityChange={onValidityChange}
    externalError={error}
    placeholder={DEFAULT_TEST_EVENT}
    minHeight={minHeight}
  />
);

export default TestEventEditor;
